import React, { useEffect, useState } from 'react';
import '../../styles/main.css';
import { fetchTopReferrors } from '../../api/action';
import maleicon from "../../assets/male.png"
import female from "../../assets/female.png"
import Paymecoin from "../../assets/PayMeCoin.png"
import fireWork from "../../assets/fireworks.png"

const genderAvatars = {
    male: maleicon,
    female: female,
  };
  

const TopReferrers = () => {
  const [referrers, setReferrers] = useState([]);
  const [month, setMonth] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchTopReferrors()
      .then((res) => {
        if (res?.data) {
          const formattedData = res.data.map((user, index) => ({
            rank: index + 1,
            name: user.user_name.trim(),
            coins: user.coins_by_reffering,
            avatar:
              genderAvatars[(user.gender || '').toLowerCase()] ||
              genderAvatars.default,
          }));

          setReferrers(formattedData);
          setMonth(res.month);
        } else {
          setError('Invalid response format');
        }
      })
      .catch(() => {
        setError('Failed to load top referrers.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  if (loading) return <div className="top-referrers">Loading top referrers...</div>;
  if (error) return <div className="top-referrers-error">{error}</div>;

  return (
    <div className="top-referrers">
      <h2 className="top-referrers-title">
        Top Referrers of the Month
        {/* {month ? `Month ${month}` : 'the Month'}  */}
        <img className='fireworkimg' src={fireWork} width={24} height={24} />
      </h2>
      <div className="referrers-list">
        {referrers.map((referrer, index) => (
          <div key={index} className="referrer-card">
            <div className="referrer-rank">{referrer.rank}</div>
            <div className="referrer-avatar">
              <img src={referrer.avatar} alt={referrer.name} />
            </div>
            <div className="referrer-details">
              <div className="referrer-name">{referrer.name}</div>
              <div className="referrer-coins">
                <span className='fontweight700'>{referrer.coins.toLocaleString()} </span>
                Coins{' '}
                <img
                  className="coin-icon"
                  src={Paymecoin}
                  alt="Coin"
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TopReferrers;
